import React from 'react';
import './ShowHidePasswordButton.scss';

interface IProps {
  clickFunction: () => void;
  passwordVisible: boolean;
  passwordFieldType: string;
}

const ShowHidePasswordButton = ({ clickFunction, passwordVisible, passwordFieldType }: IProps) => (
  <div
    className="ShowHidePasswordButton d-flex align-items-center justify-content-center"
    role="button"
    tabIndex={0}
    aria-pressed={passwordVisible}
    onClick={clickFunction}
    onKeyDown={(e) => {
      if (e.key !== 'Enter') {
        return;
      }

      clickFunction();
    }}
  >
    <span className="material-icons mx-1" aria-hidden="true">
      {passwordFieldType === 'password' ? 'visibility' : 'visibility_off'}
    </span>

    {passwordFieldType === 'password' ? 'Show' : 'Hide'}
  </div>
);

export default ShowHidePasswordButton;
